<app-vis-dialog title="新增批號" [show]="show"
  [superWidth]="'calc(70vw * var(--zoom-correction))'" [maxWidth]="'calc(70vw * var(--zoom-correction))'"
  (close)="onCancel()">

  <div style="max-height: calc(70vh * var(--zoom-correction)); overflow-y: auto;" class="dialog-pad">
    <div class="batch-grid-hint mb-2">※ 以下為單據中的新批號，確認後將隨單據儲存一併建立。</div>
    <!-- 允許過期模式 (批號期初分配)：已過期批號不擋、不紅底，僅中性提醒 -->
    <div class="batch-grid-hint batch-expired-hint mb-2" *ngIf="hasExpiredRows">※ 部分批號的有效日期已過期。</div>

    <app-vis-grid [data]="rows" class="no-border batch-grid">
      <app-vis-grid-column title="貨號" [width]="80">
        <ng-template let-data>{{ data.ProductCode }}</ng-template>
      </app-vis-grid-column>
      <app-vis-grid-column title="商品" [width]="280">
        <ng-template let-data>
          <div class="ellipsis-content" [title]="data.ProductName">{{ data.ProductName }}</div>
        </ng-template>
      </app-vis-grid-column>
      <app-vis-grid-column title="有效天數" [width]="70">
        <ng-template let-data>{{ data.expirationDays === null ? '' : data.expirationDays }}</ng-template>
      </app-vis-grid-column>
      <app-vis-grid-column title="批號" [width]="180">
        <ng-template let-data>
          <input class="vis-grid-input" maxlength="30"
            [class.error-cell]="hasBatchNoError(data)"
            [ngModel]="data.BatchNo"
            (ngModelChange)="onBatchNoChange(data, $event)" />
        </ng-template>
      </app-vis-grid-column>
      <app-vis-grid-column title="製造日期" [width]="150">
        <ng-template let-data>
          <app-vis-datepicker
            [class.error-cell]="hasManufactureDateError(data)"
            [ngModel]="data.ManufactureDate"
            (ngModelChange)="onManufactureDateChange(data, $event)">
          </app-vis-datepicker>
        </ng-template>
      </app-vis-grid-column>
      <app-vis-grid-column title="有效日期" [width]="150">
        <ng-template let-data>
          <app-vis-datepicker
            [class.error-cell]="hasExpirationDateError(data)"
            [ngModel]="data.ExpirationDate"
            (ngModelChange)="onExpirationDateChange(data, $event)">
          </app-vis-datepicker>
        </ng-template>
      </app-vis-grid-column>
      <app-vis-grid-column title="備註" [width]="160">
        <ng-template let-data>
          <input class="vis-grid-input" maxlength="500" [(ngModel)]="data.Remark" />
        </ng-template>
      </app-vis-grid-column>
    </app-vis-grid>
  </div>

  <app-vis-dialog-actions>
    <button type="button" (click)="onConfirm()" [disabled]="isSaving">確認</button>
    <button type="button" (click)="onCancel()" [disabled]="isSaving">取消</button>
  </app-vis-dialog-actions>
</app-vis-dialog>
